import React from 'react';
import NoSSR from 'react-no-ssr';
import ChipEdit from 'ChipEdit';
import transform from '../../../common/transform';
import PropTypes from 'prop-types';
import styles from './index.css';
import Header from './header';
import Content from './content';
import Footer from '@ifeng-fe/container_content/common/client/components/footer';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Affix from './affix';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;

        const {
            docData,
            docData: { breadCrumbdata },
            slideData,
            footer,
            chipObj,
            bottomAd,
            rightAd,
            recommend,
            lastAd,
            floatAd,
            interact,
            hasCopyRight,
            sourceReason,
        } = content;

        const contentData = {
            chipObj,
            bottomAd,
            rightAd,
            recommend,
            lastAd,
            interact,
            hasCopyRight,
            sourceReason,
        };

        const headerData = {
            breadCrumbdata,
        };

        const affixData = {
            chipObj,
            floatAd,
        };

        return (
            <div>
                <Header headerData={headerData} />
                <Content content={contentData} docData={docData} slideData={slideData} />
                <div className={styles.footer}>
                    <Footer content={footer} />
                </div>
                <NoSSR>
                    <Affix content={affixData} leftRef={this.leftRef} rightRef={this.rightRef} />
                </NoSSR>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
